import angular from 'angular';
import _ from 'lodash';
import Logger from '../../../../../shared/logger';

export const AnnualPerformanceService = (StatsService, $q, $filter) => {
    const monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const initDataSource = function (targets, targetField) {
        const data = [];
        const date = new Date();
        let currentMonth = date.getMonth();
        let currentYear = date.getFullYear();
        let annualTargets = _.find(targets, 'annualPerformance');
        annualTargets = annualTargets.annualPerformance;
        const target = _.get(annualTargets, `[${targetField}][${currentYear}][${currentMonth + 1}]`);
        for (let i = 0; i < 12; i++) {
            data.push({
                activeJobs: 0,
                date: `${monthName[currentMonth]} ${currentYear}`,
                target,
                month: currentMonth,
                year: currentYear,
            });
            currentMonth -= 1;
            if (currentMonth < 0) {
                currentMonth = 11;
                currentYear -= 1;
            }
        }
        return data;
    };

    const updateDataScource = function (dataSource, data, actualField) {
        for (let i = 0; i < data.length; i++) {
            const monthData = _.find(dataSource, {
                month: data[i].month - 1,
                year: data[i].year
            });
            if (monthData) {
                monthData.activeJobs = Math.round(data[i][actualField]);
            }
        }
    };

    const getAnnualPerformanceData = function (fromDate, type, targets, callback) {
        let dataSource;

        if (type === 'New Jobs') {
            StatsService.getNewByTimeFramePositions({ from: fromDate })
                .then((response) => {
                    dataSource = initDataSource(targets, 'activeJobs');
                    updateDataScource(dataSource, response.result, 'count', 'activeJobs', targets);
                    callback({
                        dataSource,
                    });
                })
                .catch(error => Logger.error(error));
        } else if (type === 'Active Jobs') {
            StatsService.getActiveByTimeFramePositions({ from: fromDate })
                .then((response) => {
                    dataSource = initDataSource(targets, 'activeJobs');
                    updateDataScource(dataSource, response.result, 'count', 'activeJobs', targets);
                    callback({
                        dataSource,
                    });
                })
                .catch(error => Logger.error(error));
        } else if (type === 'Jobs in Process') {
            StatsService.getPositionsInProcessByTimeFrame({ from: fromDate })
                .then((response) => {
                    dataSource = initDataSource(targets, 'jobsInProcess');
                    updateDataScource(dataSource, response.result, 'count', 'jobsInProcess', targets);
                    callback({
                        dataSource,
                    });
                })
                .catch(error => Logger.error(error));
        } else if (type === 'Advanced jobs') {
            StatsService.getpositionsInAdvancedProcessByTimeFrame({ from: fromDate })
                .then((response) => {
                    dataSource = initDataSource(targets, 'advancedJobs');
                    updateDataScource(dataSource, response.result, 'count', 'advancedJobs', targets);
                    callback({
                        dataSource,
                    });
                })
                .catch(error => Logger.error(error));
        } else if (type === 'Average Time To Hire') {
            StatsService.getByTimeFrameAverageTimeToHire({ from: fromDate })
                .then((response) => {
                    dataSource = initDataSource(targets, 'averageTimeToHire');
                    updateDataScource(dataSource, response.result, 'averageTimeToHireInDays', 'averageTimeToHire', targets);
                    callback({
                        dataSource,
                    });
                })
                .catch(error => Logger.error(error));
        } else if (type === 'Number Of Hires') {
            StatsService.getByTimeFrameNumberOfHires({ from: fromDate })
                .then((response) => {
                    dataSource = initDataSource(targets, 'numberOfHires');
                    updateDataScource(dataSource, response.result, 'count', 'numberOfHires', targets);
                    callback({
                        dataSource,
                    });
                })
                .catch(error => Logger.error(error));
        } else if (type === 'Active Employers') {
            StatsService.getActiveByTimeFrameEmployers({ from: fromDate })
                .then((response) => {
                    dataSource = initDataSource(targets, 'activeEmployers');
                    updateDataScource(dataSource, response.result, 'count', 'activeEmployers', targets);
                    callback({
                        dataSource,
                    });
                })
                .catch(error => Logger.error(error));
        } else if (type === 'New Employers') {
            StatsService.getNewEmployersByTimeFrame({ from: fromDate })
                .then((response) => {
                    dataSource = initDataSource(targets, 'newEmployers');
                    updateDataScource(dataSource, response.result, 'count', 'newEmployers', targets);
                    callback({
                        dataSource,
                    });
                })
                .catch(error => Logger.error(error));
        } else if (type === 'Profile Sent') {
            StatsService.getProfilesSentByTimeFrame({ from: fromDate })
                .then((response) => {
                    dataSource = initDataSource(targets, 'profilesSent');
                    updateDataScource(dataSource, response.result, 'count', 'profilesSent', targets);
                    callback({
                        dataSource,
                    });
                })
                .catch(error => Logger.error(error));
        }
    };

    const getAnnualPerformanceOptions = function (dataSource) {
        const target_Color = '#F8C052';
        const activeJobs_Color = '#4362A4';
        dataSource = dataSource.reverse();
        const options = {
            dataSource,
            barWidth: 0.59,
            size: {
                height: 215,
            },
            commonSeriesSettings: {
                argumentField: 'date',
                type: 'bar',
                point: {
                    visible: false,
                    symbol: 'square',
                },
            },
            commonAxisSettings: {
                grid: {
                    visible: true, // Show Horizonatl Grid lines
                },
            },
            argumentAxis: {
                valueMarginsEnabled: false,
                discreteAxisDivisionMode: 'crossLabels',
                label: {
                    visible: true, // Show text labels
                    font: {
                        color: '#000000',
                        family: 'Source Sans Pro',
                        weight: 400,
                        size: 12,
                    },
                },
                grid: {
                    visible: false, // Remove Vertical Grid lines
                },
            },
            valueAxis: {
                discreteAxisDivisionMode: 'crossLabels',
                label: {
                    visible: true, // Show text labels
                    font: {
                        color: '#000000',
                        family: 'Source Sans Pro',
                        weight: 400,
                        size: 12,
                    },
                    tickInterval: 25,
                },
            },
            series: [
                {
                    argumentField: 'date',
                    valueField: 'activeJobs',
                    name: $filter('translate')('ANNUAL_PERFORMANCE_ACTUAL'),
                    type: 'bar',
                    color: activeJobs_Color,
                },
                {
                    argumentField: 'date',
                    valueField: 'target',
                    name: 'Target',
                    type: 'line',
                    color: target_Color,
                    point: {
                        visible: true,
                    },
                    showInLegend: true,
                },
            ],
            label: {
                visible: true,
                customizeText(pointInfo) {
                    return `${pointInfo.value}`;
                },
                verticalOffset: 10,
                backgroundColor: '#ffffff',
                font: {
                    color: '#000000',
                    family: 'Source Sans Pro',
                    weight: 400,
                    size: 12,
                },
            },
            legend: {
                font: {
                    color: '#000000',
                    family: 'Source Sans Pro',
                    weight: 400,
                    size: 15,
                },
                margin: {
                    top: 20,
                },
                orientation: 'horizontal',
                verticalAlignment: 'bottom',
                horizontalAlignment: 'center',
                itemsAlignment: 'left',
                itemTextPosition: 'right',
                markerSize: 10,
            },
            export: {
                enabled: false,
            },
            tooltip: {
                enabled: true,
                paddingLeftRight: 13,
                paddingTopBottom: 4,
                customizeTooltip(argObj) {
                    const row1BackgroundColor = activeJobs_Color;
                    const row2BackgroundColor = target_Color;

                    // No ES6 - Find the spcecific data in the 'dataSource' array (For backwards compatability, without ES6)
                    let foundIndex = -1;
                    for (let i = 0; i < dataSource.length; ++i) {
                        if (dataSource[i].date == argObj.argumentText) {
                            foundIndex = i;
                            break;
                        }
                    }
                    const foundObj = dataSource[foundIndex];
                    const row1Text = foundObj.activeJobs;
                    const row2Text = foundObj.target;

                    return {
                        html: `${'<div class=\'custom-chart-tooltip\'>' +
                        '<div class=\'tooltip-row\'>' +
                        '<div class=\'tooltip-legend inline-block\' style=\'background-color: '}${row1BackgroundColor}'>` +
                        '&nbsp;</div>' +
                        `<div class='tooltip-legend-text inline-block'>${row1Text}</div>` +
                        '</div>' +

                        '<div class=\'tooltip-row\'>' +
                        `<div class='tooltip-legend inline-block' style='background-color: ${row2BackgroundColor}'>` +
                        '&nbsp;</div>' +
                        `<div class='tooltip-legend-text inline-block'>${row2Text}</div>` +
                        '</div>' +
                        '</div>',
                    };
                },
            },
        };
        return options;
    };

    const getActivitySnapshotOptions = function (dataSource, targets) {
        let currentMonthData = 0;
        let lastMonthData = 0;
        let currentYearData = 0;
        let lastYearData = 0;
        let sameMonthLastYear = 0;
        const placementData = _.find(targets, 'placements');
        let numberOfHiresTargets = _.find(targets, 'annualPerformance');
        numberOfHiresTargets = numberOfHiresTargets.annualPerformance.numberOfHires;
        dataSource = dataSource.reverse();
        const curDate = new Date();
        const curMonth = curDate.getMonth();
        const curYear = curDate.getFullYear();
        let monthText = `${monthName[curMonth]} ${curYear}`;
        const thisMonthTargetData = _.get(numberOfHiresTargets,`[${curYear}][${curMonth + 1}]`);
        /* current month */
        let idx = _.findIndex(dataSource, { date: monthText });
        if (idx >= 0) {
            currentMonthData = dataSource[idx].activeJobs;
        }
        /* reset parameters */
        idx = -1;
        monthText = '';
        if (curMonth == 0) {
            monthText = `${monthName[11]} ${curYear - 1}`;
        } else {
            monthText = `${monthName[curMonth - 1]} ${curYear}`;
        }
        /* last month */
        idx = _.findIndex(dataSource, { date: monthText });
        if (idx >= 0) {
            lastMonthData = dataSource[idx].activeJobs;
        }
        /* reset parameters */
        idx = -1;
        monthText = '';
        monthText = `${monthName[curMonth]} ${curYear - 1}`;
        /* same year current month */
        idx = _.findIndex(dataSource, { date: monthText });
        if (idx >= 0) {
            sameMonthLastYear = dataSource[idx].activeJobs;
        }
        /* current year */
        let data = _.filter(dataSource, { year: curYear });
        if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                currentYearData += data[i].activeJobs;
            }
        }
        /* last year */
        data = _.filter(dataSource, { year: curYear - 1 });
        if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                lastYearData += data[i].activeJobs;
            }
        }

        const monthDataSource = [{
            timeSpan: monthText,
            placements: sameMonthLastYear,
        }, {
            timeSpan: 'Previous Month',
            placements: lastMonthData,
        }, {
            timeSpan: 'This Month Target',
            placements: thisMonthTargetData,
        }, {
            timeSpan: 'This Month Projection',
            placements: placementData.placements.projected.monthly,
        }, {
            timeSpan: 'Current Month',
            placements: currentMonthData,
        }];

        const YearDataSource = [{
            timeSpan: '', // Empty, used as a placeholder only
            placements: 0,
        }, {
            timeSpan: 'Last Year',
            placements: lastYearData,
        }, {
            timeSpan: 'This Year Target',
            placements: placementData.placements.target.yearly,
        }, {
            timeSpan: 'This Year Projection',
            placements: placementData.placements.projected.yearly,
        }, {
            timeSpan: 'Current Year',
            placements: currentYearData,
        }];

        const monthOptions = {
            palette: ['#193779'], // Set a default color
            dataSource: monthDataSource,
            rotated: true, // Make Chart Horizonatal
            customizePoint() {
                const customColorPaletteM = ['#0a2242', '#39619d', '#587db6', '#88a8d5', '#b1bed1'];

                // Use 'index' to set the color, from 'customColorPalette'
                if (this.index == 0) {
                    return { color: customColorPaletteM[4] };
                }
                // Use 'argument' to set the color, from 'customColorPalette'
                else if (this.argument == 'Previous Month') {
                    return { color: customColorPaletteM[3] };
                } else if (this.argument == 'This Month Target') {
                    return { color: customColorPaletteM[2] };
                } else if (this.argument == 'This Year Projection') {
                    return { color: customColorPaletteM[1] };
                } else if (this.argument == 'Current Month') {
                    return { color: customColorPaletteM[0] };
                }
            },
            size: {
                height: 118,
                width: 290,
            },
            commonSeriesSettings: {
                argumentField: 'timeSpan',
                type: 'bar',
                point: {
                    visible: false,
                },
            },
            commonAxisSettings: {
                label: {
                    font: {
                        color: '#000000',
                        family: 'Source Sans Pro',
                        weight: 400,
                        size: 12,
                    },
                },
                grid: {
                    visible: false, // Remove Horizonatl Grid lines
                },

            },
            margin: {
                bottom: 10,
            },
            argumentAxis: {
                valueMarginsEnabled: false,
                discreteAxisDivisionMode: 'crossLabels',
                grid: {
                    visible: false, // Remove Vertical Grid lines
                },
            },
            series: [
                {
                    valueField: 'placements',
                    name: 'Placements',
                },
            ],
            legend: {
                visible: false,
            },
            export: {
                enabled: false,
            },
            tooltip: {
                enabled: true,
                customizeTooltip(arg) {
                    return {
                        text: arg.valueText,
                    };
                },
            },
        };

        const yearOptions = {
            palette: ['#193779'], // Set a default color
            dataSource: YearDataSource,
            rotated: true, // Make Chart Horizonatal
            customizePoint() {
                const customColorPalette = ['#faa085', '#fa744c', '#e45226', '#bc3803'];

                // Use 'index' to set the color, from 'customColorPalette'
                if (this.index == 0) {
                    return {};
                }
                // Use 'argument' to set the color, from 'customColorPalette'
                else if (this.argument == 'Current Year') {
                    return { color: customColorPalette[3] };
                } else if (this.argument == 'This Year Target') {
                    return { color: customColorPalette[1] };
                } else if (this.argument == 'This Year Projection') {
                    return { color: customColorPalette[2] };
                } else if (this.argument == 'Last Year') {
                    return { color: customColorPalette[0] };
                }
            },
            size: {
                height: 118,
                width: 290,
            },
            commonSeriesSettings: {
                argumentField: 'timeSpan',
                type: 'bar',
                point: {
                    visible: false,
                },
            },
            // argumentAxis
            // valueAxis
            commonAxisSettings: {
                label: {
                    font: {
                        color: '#000000',
                        family: 'Source Sans Pro',
                        weight: 400,
                        size: 12,
                    },
                },
                grid: {
                    visible: false, // Remove Horizonatl Grid lines
                },

            },
            margin: {
                bottom: 10,
            },
            argumentAxis: {
                valueMarginsEnabled: false,
                discreteAxisDivisionMode: 'crossLabels',
                grid: {
                    visible: false, // Remove Vertical Grid lines
                },
            },
            series: [
                {
                    valueField: 'placements',
                    name: 'Placements',
                },
            ],
            legend: {
                visible: false,
            },
            export: {
                enabled: false,
            },
            tooltip: {
                enabled: true,
                customizeTooltip(arg) {
                    return {
                        text: arg.valueText,
                    };
                },
            },
        };

        return [monthOptions, yearOptions];
    };

    return {
        getAnnualPerformanceData,
        getAnnualPerformanceOptions,
        getActivitySnapshotOptions,
    };
};

angular
    .module('TALENYA-FE')
    .factory('AnnualPerformanceService', AnnualPerformanceService);

